import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import "./styles.scss";
import * as moment from "moment";
import mentorshipMiniCircle from "../../../assets/svg/ mentroshipsMiniCircle.svg";
import startupMiniCircle from "../../../assets/svg/startupMiniCircle.svg";
import hashImage from "../../../assets/images/hashImage.jpeg";
import mentorMiniIcon from "../../../assets/svg/mentorsMiniCircle.svg";
import Pagination from "react-js-pagination";
import profile from "../../../assets/svg/dashboard/profile-iconRound.svg";
import { getmatchTableList } from "../../AdminModule/Dashboard/MentorDashboard/dependencies/action";
import ModalRequirement from "../../AdminModule/Dashboard/StartupDashboard/MyRequests/Modal/modal";
import { deleteSessionData } from "../../AdminModule/Dashboard/StartupDashboard/dependencies/action";
import * as CryptoJS from "crypto-js";
import { PROFILE_KEY } from "../constants/actionConstants";
function MentorshipSummayModal(props) {
  class AesUtil {
    constructor(keySize, iterationCount) {
      this.keySize = keySize / 32;
      this.iterationCount = iterationCount;
    }
  
    generateKey = function (salt, passPhrase) {
      let key = CryptoJS.PBKDF2(passPhrase, CryptoJS.enc.Hex.parse(salt), {
        keySize: this.keySize,
        iterations: this.iterationCount,
      });
      return key;
    };
  
    encrypt = function (salt, iv, passPhrase, plainText) {
      let key = this.generateKey(salt, passPhrase);
      let encrypted = CryptoJS.AES.encrypt(plainText, key, {
        iv: CryptoJS.enc.Hex.parse(iv),
      });
      return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
    };
  }
  const encryptAES2 = (text, key) => {
    // let iv = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
    // let salt = CryptoJS.lib.WordArray.random(128 / 8).toString(CryptoJS.enc.Hex);
  
    // let aesUtil = new AesUtil(128, 1000);
    // let ciphertext = aesUtil.encrypt(salt, iv, key, text);
  
    // let aesText = iv + "::" + salt + "::" + ciphertext;
    
    return btoa(text);
  };
  const [modalOpen2, setModalOpen2] = useState(false);
  const [modalData2, setModalData2] = useState();
  const [modalData, setModalData] = useState();
  const [modalOpen3, setModalOpen3] = useState(false);
  const [modalData3, setModalData3] = useState();
  const LoginUser = JSON.parse(localStorage.getItem("SavedLoggedInData"));
  const {
    getmatchTableList,
    cohortMatchMakingList,
    modalVisibility,
    cohortId,
    cohortMatchPaginate,
  } = props;
  const [activePage, setActivePage] = useState(1);

  useEffect(() => {
    createMentorMatchInitial();
  }, [modalVisibility]);

  const createMentorMatchInitial = () => {
    let params = {
      cohortAdminId: LoginUser.id,
      cohortId: cohortId,
      pageFilter: {
        currentPage: 0,
        includeCount: true,
        pageSize: 5,
        sortField: "name",
        sortOrder: "ASC",
      },
    };
    getmatchTableList(params);
  };
  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
    let params = {
      cohortAdminId: LoginUser.id,
      cohortId: cohortId,
      pageFilter: {
        currentPage: pageNumber - 1,
        includeCount: true,
        pageSize: 5,
        sortField: "name",
        sortOrder: "ASC",
      },
    };
    getmatchTableList(params);

    // getStartupApplication(params);
  };
  useEffect(() => {
    if (cohortMatchMakingList && cohortMatchMakingList.length > 0) {
      setModalData(cohortMatchMakingList);
    }
  }, [cohortMatchMakingList]);
  const currentRoute = window.location.href;
  let sample;
  sample = currentRoute.slice(0, currentRoute.lastIndexOf("/"));

  const [requestJsonArr, setRequestJsonArr] = useState([]);
  const LoginRole = JSON.parse(localStorage.getItem("SavedLoggedInData"))?.role;
  const handleClose = () => {
    props.setModalVisibility(false);
  };
  const ViewProfile = (item, id) => {
    // setSelectedRow(id);
    let reRoute = window.open(sample + `/mentor-profile/${encryptAES2(item,PROFILE_KEY)}`, "_blank");
    // let reRoute = window.open(sample + `/mentor-profile/${item}`, "_blank");
    reRoute.id = item;
  };
  const redirectProfile = (dpiitNo) => {
    let reRoute = window.open(sample + "/startup-profile", "_blank");
    reRoute.id = dpiitNo;
  };
  const handleViewProfile = () => {};
  //   useEffect(() => {
  //     let reqJson;
  //
  //     if (modalData && props.fromPage && props.fromPage === "mentorships") {
  //       modalData.forEach(item => {
  //         reqJson = {
  //           industry: [item.industry],
  //           sub_industry: item.subindustry,
  //           function: item.sectors,
  //           sub_function: item.subspecialization,
  //           stage: item.stage,
  //         }
  //         setRequestJsonArr((data) => [...data, reqJson])
  //       },)
  //   }},[modalData]);
  useEffect(() => {}, [requestJsonArr]);

  return (
    <>
      <div className="modal-dialog modal-dialog-centered ">
        <Modal
          size="lg"
          show={props?.modalVisibility}
          onHide={() => props.setModalVisibility(false)}
          aria-labelledby="example-modal-sizes-title-lg"
          style={{ borderRadius: "7px", minWidth: "100vw" }}
          dialogClassName="mentorshipModal"
        >
          <Modal.Header
            className="d-flex "
            style={{ justifyContent: "space-between" }}
          >
            <Modal.Title className="modalHeading">
              MENTORSHIP SUMMARY
            </Modal.Title>
            <div className="newuserTooltip">
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={handleClose}
              />
              <span
                className="tooltiptext  close-window"
                style={{ left: "-130px", top: "2px", width: "130px" }}
              >
                Close Window
              </span>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="session-detailsModal viewmntrshipmobiletablediv">
              <div className="col-md-10 session-detailwhole">
                <div className="totalTableCount">
                  Total Mentorships Found : {cohortMatchPaginate?.totalElements}{" "}
                  &lt; {cohortMatchPaginate?.currentPage} of{" "}
                  {cohortMatchPaginate?.numPages} &gt;
                </div>
                <table
                  //  id="session"
                  className="cohortSummaryTable4"
                >
                  {/* <th
                    style={{ verticalAlign: "middle" }}
                    className="fixColumbnWidth4"
                  >
                    NO
                  </th>
                  <th style={{ verticalAlign: "middle" }} colspan="2">
                    MENTOR
                  </th>
                  <th style={{ verticalAlign: "middle" }} colspan="2">
                    STARTUP
                  </th>
                  <th style={{ verticalAlign: "middle" }}>MENTORSHIP ID</th> */}
                  <tbody>
                    {modalData && modalData.length > 0 ? (
                      modalData.map((item, index) => (
                        <tr>
                          <td
                            style={{
                              verticalAlign: "top",
                              width: "100%",
                              borderRight: "none",
                            }}
                          >
                            <div>
                              {index +
                                1 +
                                5 * (cohortMatchPaginate.currentPage - 1)}
                            </div>
                          </td>
                          <td
                            style={{
                              verticalAlign: "top",
                              width: "100%",
                              marginLeft: "0px",
                              borderRight: "none",
                            }}
                            className="row"
                          >
                            <div
                              className="newuserTooltip"
                              style={{
                                width: "100px",
                                height: "100px",
                                maxWidth: "none",
                                objectFit: "contain",
                              }}
                            >
                              <img
                                src={item.mentorImage}
                                onClick={() =>
                                  ViewProfile(item?.mentorEmail, item?.mentorId)
                                }
                                className="sidebar-dashboard-icon2 newWidthIconFIx"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "contain",
                                  cursor: "pointer",
                                }}
                              />
                              <span
                                className="tooltiptext tooltip-bottom "
                                style={{
                                  left: "46px",
                                  top: "94px",
                                  width: "150px",
                                }}
                              >
                                View Mentor Profile
                              </span>
                            </div>
                            <div style={{ textAlign: "right" }}>
                              <div>
                                {"M" +
                                  item.mentorId.substring(
                                    item.mentorId.length - 6
                                  )}
                              </div>
                              <div className="mt-1">{item.mentorName}</div>

                              <div className="mt-1">
                                Cohort Mentorships : {item.cohortMentorships}
                              </div>
                              <div className="mt-1">
                                Other Mentorships : {item.otherMentorships}
                              </div>
                              <div
                                className="d-flex justify-content-end newuserTooltip"
                                style={{
                                  cursor: "pointer",
                                  alignItems: "end",
                                  justifyContent: "center",
                                  width: "40px",
                                  display: "flex",
                                  float: "right",
                                }}
                                onClick={() =>
                                  ViewProfile(item?.mentorEmail, item?.mentorId)
                                }
                              >
                                <img src={mentorMiniIcon} />
                                <span
                                  className="tooltiptext tooltip-bottom"
                                  style={{
                                    left: "15px",
                                    top: "45px",
                                    width: "150px",
                                  }}
                                >
                                  View Mentor Profile
                                </span>
                              </div>
                            </div>
                          </td>

                          <td
                            className="matchList-tooltip p-0 row mnsumstrtuphead"
                            style={{
                              width: "100%",
                              border: "none",
                              marginLeft: "0px",
                            }}
                          >
                            {item?.mentorships !== undefined &&
                              item?.mentorships?.length > 0 &&
                              item?.mentorships.map(function (key, index) {
                                return (
                                  <>
                                    <div
                                      className="row"
                                      style={{
                                        justifyContent: "right",
                                        textAlign: "right",
                                        paddingRight: "0px",
                                        marginLeft: "0px",
                                        borderBottom: "1px solid lightgray",
                                      }}
                                    >
                                      <div
                                        className="newuserTooltip"
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          maxWidth: "none",

                                          objectFit: "contain",
                                        }}
                                      >
                                        <img
                                          src={
                                            key?.startup?.logo === null ||
                                            key?.startup?.logo === ""
                                              ? hashImage
                                              : key?.startup?.logo
                                          }
                                          onClick={() => {
                                            // setIndexCounter(item.requestId);
                                            redirectProfile(
                                              key?.startup?.dippNumber
                                            );
                                          }}
                                          className="sidebar-dashboard-icon2"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "contain",
                                            cursor: "pointer",
                                            position: "relative",
                                            // left: "1.25rem",
                                            bottom: "0.3rem",
                                          }}
                                        />
                                        <span
                                          className="tooltiptext tooltip-bottom "
                                          style={{
                                            left: "46px",
                                            top: "94px",
                                            width: "150px",
                                            display: "none",
                                          }}
                                        >
                                          View Startup Profile
                                        </span>
                                      </div>
                                      <div>
                                        <div
                                          style={{
                                            position: "relative",
                                            // top: "0.5rem",
                                            width: "100%",
                                            border: "none",
                                            cursor: "pointer",
                                          }}
                                          className="color-green newuserTooltip"
                                          onClick={() => {
                                            let requestJson = {
                                              industry:
                                                key.mentorRequest.requestJson
                                                  .industry,
                                              sub_industry:
                                                key.mentorRequest.requestJson
                                                  .sub_industry,
                                              function:
                                                key.mentorRequest.requestJson
                                                  .function,
                                              sub_function:
                                                key.mentorRequest.requestJson
                                                  .sub_function,
                                              stage:
                                                key.mentorRequest.requestJson
                                                  .stage,
                                              purpose:
                                                key.mentorRequest
                                                  .purposeOfMentorship,
                                            };
                                            setModalData3(requestJson);
                                            setModalOpen3(true);
                                          }}
                                        >
                                          {"S" +
                                            key?.startup?.id.substring(
                                              key?.startup?.id.length - 6
                                            )}
                                          <span
                                            className="tooltiptext tooltip-bottom"
                                            style={{
                                              left: "3rem",
                                              top: "33px",
                                              width: "221px",
                                            }}
                                          >
                                            View Mentorship Requirement
                                          </span>
                                        </div>
                                        <div
                                          style={{
                                            position: "relative",
                                            // top: "0.75rem",
                                          }}
                                        >
                                          {key?.startup?.organization_name}
                                        </div>

                                        <div
                                          style={{
                                            position: "relative",
                                            // top: "0.75rem",
                                          }}
                                        >
                                          {"R" +
                                            key?.requestId.substring(
                                              key?.requestId.length - 6
                                            )}
                                          <div
                                            className="newuserTooltip iconnew"
                                            style={{
                                              cursor: "pointer",
                                              // position: "absolute",
                                              padding: "10px",
                                              right: "0px",
                                              bottom: "0px",
                                              paddingRight: "0px",
                                            }}
                                            onClick={() => {
                                              redirectProfile(
                                                key?.startup?.dippNumber
                                              );
                                            }}
                                          >
                                            <img
                                              src={startupMiniCircle}
                                              height={40}
                                              width={40}
                                              style={{
                                                float: "right",
                                                marginBottom: "10px",
                                              }}
                                            />
                                            <span
                                              className="tooltiptext tooltip-bottom "
                                              style={{
                                                left: "46px",
                                                top: "60px",
                                                width: "150px",
                                              }}
                                            >
                                              View Startup Profile
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                      <div>
                                        <div
                                          style={{
                                            display: "flex",
                                            minWidth: "9.2rem",
                                            textAlign: "right",
                                            paddingBottom: "10px",
                                          }}
                                          className="borderStartUp7"
                                        >
                                          <div>
                                            <div>
                                              <div style={{ fontSize: "13px" }}>
                                                MENTORSHIP ID
                                              </div>
                                              <div>
                                                M
                                                {key?.id.substring(
                                                  key?.id?.length - 6
                                                )}
                                              </div>
                                            </div>
                                            <div>
                                              {moment(
                                                key?.mentorshipDate
                                              ).format("DD/MM/YYYY")}
                                            </div>
                                          </div>
                                          <div
                                            className="newuserTooltip"
                                            style={{
                                              cursor: "pointer",
                                              justifyContent: "flex-end",
                                              display: "flex",
                                              // marginTop: "1.85rem",
                                            }}
                                            onClick={() => {
                                              window.open(
                                                `/mentor-dashboard/mentorships/engagement-summary/${key?.id}`,
                                                "_blank"
                                              );
                                            }}
                                          >
                                            <img
                                              src={mentorshipMiniCircle}
                                              className="miniStartupCircle22"
                                              style={{
                                                width: "40px",
                                                margin: "unset",
                                              }}
                                            />
                                            {/* <span
                                          className="tooltiptext tooltip-bottom  "
                                          style={{
                                            left: "47px",
                                            width: "148px",
                                            top: "80px",
                                            height: "51px",
                                          }}
                                        >
                                          View Mentorship Engagement
                                        </span> */}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                          </td>
                          <td
                            className="matchList-tooltip p-0 shuldbehidden"
                            style={{ position: "relative", display: "none" }}
                          >
                            {item?.mentorships !== undefined &&
                              item?.mentorships?.length > 0 &&
                              item?.mentorships.map(function (key, index) {
                                return (
                                  <>
                                    <td
                                      style={{
                                        display: "flex",
                                        // justifyContent: "center",
                                        minWidth: "19.5rem",
                                        maxWidth: "19.6rem",
                                      }}
                                      className="borderStartUp7"
                                    >
                                      <div className="">
                                        <div
                                          style={{
                                            position: "relative",
                                            // top: "0.5rem",
                                            width: "max-content",
                                            cursor: "pointer",
                                          }}
                                          className="color-green newuserTooltip"
                                          onClick={() => {
                                            let requestJson = {
                                              industry:
                                                key.mentorRequest.requestJson
                                                  .industry,
                                              sub_industry:
                                                key.mentorRequest.requestJson
                                                  .sub_industry,
                                              function:
                                                key.mentorRequest.requestJson
                                                  .function,
                                              sub_function:
                                                key.mentorRequest.requestJson
                                                  .sub_function,
                                              stage:
                                                key.mentorRequest.requestJson
                                                  .stage,
                                              purpose:
                                                key.mentorRequest
                                                  .purposeOfMentorship,
                                            };
                                            setModalData3(requestJson);
                                            setModalOpen3(true);
                                          }}
                                        >
                                          {"S" +
                                            key?.startup?.id.substring(
                                              key?.startup?.id.length - 6
                                            )}
                                          <span
                                            className="tooltiptext tooltip-bottom"
                                            style={{
                                              left: "3rem",
                                              top: "33px",
                                              width: "221px",
                                            }}
                                          >
                                            View Mentorship Requirement
                                          </span>
                                        </div>
                                        <div
                                          style={{
                                            position: "relative",
                                            // top: "0.75rem",
                                          }}
                                        >
                                          {key?.startup?.organization_name}
                                        </div>

                                        <div
                                          style={{
                                            position: "relative",
                                            // top: "0.75rem",
                                          }}
                                        >
                                          {"R" +
                                            key?.requestId.substring(
                                              key?.requestId.length - 6
                                            )}
                                        </div>
                                        <div
                                          className="newuserTooltip"
                                          style={{
                                            cursor: "pointer",
                                            position: "absolute",
                                            padding: "12px",
                                            right: "0px",
                                            bottom: "0px",
                                          }}
                                          onClick={() => {
                                            redirectProfile(
                                              key?.startup?.dippNumber
                                            );
                                          }}
                                        >
                                          <img
                                            src={startupMiniCircle}
                                            height={40}
                                            width={40}
                                          />
                                          <span
                                            className="tooltiptext tooltip-bottom "
                                            style={{
                                              left: "46px",
                                              top: "60px",
                                              width: "150px",
                                            }}
                                          >
                                            View Startup Profile
                                          </span>
                                        </div>
                                      </div>
                                    </td>
                                  </>
                                );
                              })}
                          </td>
                          <td
                            className="matchList-tooltip p-0 row"
                            style={{ width: "100%", display: "none" }}
                          >
                            {item.mentorships !== undefined &&
                              item.mentorships?.length > 0 &&
                              item.mentorships.map(function (key, index) {
                                return (
                                  <>
                                    <div
                                      style={{
                                        display: "flex",
                                        minWidth: "9.2rem",
                                        textAlign: "right",
                                      }}
                                      className="borderStartUp7"
                                    >
                                      <div>
                                        <div>
                                          M
                                          {key?.id.substring(
                                            key?.id?.length - 6
                                          )}
                                        </div>
                                        <div>
                                          {moment(key?.mentorshipDate).format(
                                            "DD/MM/YYYY"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        className="newuserTooltip"
                                        style={{
                                          cursor: "pointer",
                                          justifyContent: "flex-end",
                                          display: "flex",
                                          marginTop: "1.85rem",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            `/mentor-dashboard/mentorships/engagement-summary/${key?.id}`,
                                            "_blank"
                                          );
                                        }}
                                      >
                                        <img
                                          src={mentorshipMiniCircle}
                                          className="miniStartupCircle22"
                                          style={{
                                            width: "40px",
                                            margin: "unset",
                                          }}
                                        />
                                        {/* <span
                                          className="tooltiptext tooltip-bottom  "
                                          style={{
                                            left: "47px",
                                            width: "148px",
                                            top: "80px",
                                            height: "51px",
                                          }}
                                        >
                                          View Mentorship Engagement
                                        </span> */}
                                      </div>
                                    </div>
                                  </>
                                );
                              })}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={8} style={{ border: "none" }}>
                          {" "}
                          <div
                            className="no-records"
                            style={{ marginLeft: "8rem" }}
                          >
                            No Matches Found
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="pagination-box">
                  {cohortMatchPaginate !== undefined && (
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={5}
                      totalItemsCount={cohortMatchPaginate?.totalElements}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange.bind(this)}
                    />
                  )}
                </div>
                <ModalRequirement
                  modalOpen={modalOpen3}
                  setModalOpen={setModalOpen3}
                  modalData={modalData3}
                />
                {/* */}
              </div>
            </div>
            <div className="session-detailsModal viewmntrshipdesktablediv">
              <div className="col-md-10 session-detailwhole">
                <div className="totalTableCount">
                  Total Mentorships Found : {cohortMatchPaginate?.totalElements}{" "}
                  &lt; {cohortMatchPaginate?.currentPage} of{" "}
                  {cohortMatchPaginate?.numPages} &gt;
                </div>
                <table
                  //  id="session"
                  className="cohortSummaryTable4"
                >
                  <th
                    style={{ verticalAlign: "middle" }}
                    className="fixColumbnWidth4"
                  >
                    NO
                  </th>
                  <th style={{ verticalAlign: "middle" }} colspan="2">
                    MENTOR
                  </th>
                  <th style={{ verticalAlign: "middle" }} colspan="2">
                    STARTUP
                  </th>
                  <th style={{ verticalAlign: "middle" }}>MENTORSHIP ID</th>
                  <tbody>
                    {modalData && modalData.length > 0 ? (
                      modalData.map((item, index) => (
                        <tr>
                          <td style={{ verticalAlign: "top" }}>
                            <div>
                              {index +
                                1 +
                                5 * (cohortMatchPaginate.currentPage - 1)}
                            </div>
                          </td>
                          <td style={{ verticalAlign: "top" }}>
                            <div
                              className="newuserTooltip"
                              style={{
                                width: "100px",
                                height: "100px",
                                maxWidth: "none",
                                objectFit: "contain",
                              }}
                            >
                              <img
                                src={item.mentorImage}
                                onClick={() =>
                                  ViewProfile(item?.mentorEmail, item?.mentorId)
                                }
                                className="sidebar-dashboard-icon2 newWidthIconFIx"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "contain",
                                  cursor: "pointer",
                                }}
                              />
                              <span
                                className="tooltiptext tooltip-bottom "
                                style={{
                                  left: "46px",
                                  top: "94px",
                                  width: "150px",
                                }}
                              >
                                View Mentor Profile
                              </span>
                            </div>
                          </td>
                          <td
                            className="mentorshipModalWidth"
                            // style={{minWidth:"23.9rem",maxWidth:"24rem",verticalAlign:"top"}}
                          >
                            <div>
                              {"M" +
                                item.mentorId.substring(
                                  item.mentorId.length - 6
                                )}
                            </div>
                            <div className="mt-1">{item.mentorName}</div>

                            <div className="mt-1">
                              Cohort Mentorships : {item.cohortMentorships}
                            </div>
                            <div className="mt-1">
                              Other Mentorships : {item.otherMentorships}
                            </div>
                            <div
                              className="d-flex justify-content-end newuserTooltip"
                              style={{
                                cursor: "pointer",
                                alignItems: "end",
                                justifyContent: "center",
                                width: "40px",
                                display: "flex",
                                float: "right",
                              }}
                              onClick={() =>
                                ViewProfile(item?.mentorEmail, item?.mentorId)
                              }
                            >
                              <img src={mentorMiniIcon} />
                              <span
                                className="tooltiptext tooltip-bottom"
                                style={{
                                  left: "15px",
                                  top: "45px",
                                  width: "150px",
                                }}
                              >
                                View Mentor Profile
                              </span>
                            </div>
                          </td>
                          <td className="matchList-tooltip p-0">
                            {item?.mentorships !== undefined &&
                              item?.mentorships?.length > 0 &&
                              item?.mentorships.map(function (key, index) {
                                return (
                                  <>
                                    <td
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        minWidth: "13.9rem",
                                        maxWidth: "14rem",
                                      }}
                                      className="borderStartUp7"
                                    >
                                      <div
                                        className="newuserTooltip"
                                        style={{
                                          width: "100px",
                                          height: "100px",
                                          maxWidth: "none",

                                          objectFit: "contain",
                                        }}
                                      >
                                        <img
                                          src={
                                            key?.startup?.logo === null ||
                                            key?.startup?.logo === ""
                                              ? hashImage
                                              : key?.startup?.logo
                                          }
                                          onClick={() => {
                                            // setIndexCounter(item.requestId);
                                            redirectProfile(
                                              key?.startup?.dippNumber
                                            );
                                          }}
                                          className="sidebar-dashboard-icon2"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "contain",
                                            cursor: "pointer",
                                            position: "relative",
                                            left: "1.25rem",
                                            bottom: "0.3rem",
                                          }}
                                        />
                                        <span
                                          className="tooltiptext tooltip-bottom "
                                          style={{
                                            left: "46px",
                                            top: "94px",
                                            width: "150px",
                                          }}
                                        >
                                          View Startup Profile
                                        </span>
                                      </div>
                                    </td>
                                  </>
                                );
                              })}
                          </td>
                          <td
                            className="matchList-tooltip p-0"
                            style={{ position: "relative" }}
                          >
                            {item?.mentorships !== undefined &&
                              item?.mentorships?.length > 0 &&
                              item?.mentorships.map(function (key, index) {
                                return (
                                  <>
                                    <td
                                      style={{
                                        display: "flex",
                                        // justifyContent: "center",
                                        minWidth: "19.5rem",
                                        maxWidth: "19.6rem",
                                      }}
                                      className="borderStartUp7"
                                    >
                                      <div className="">
                                        <div
                                          style={{
                                            position: "relative",
                                            // top: "0.5rem",
                                            width: "max-content",
                                            cursor: "pointer",
                                          }}
                                          className="color-green newuserTooltip"
                                          onClick={() => {
                                            let requestJson = {
                                              industry:
                                                key.mentorRequest.requestJson
                                                  .industry,
                                              sub_industry:
                                                key.mentorRequest.requestJson
                                                  .sub_industry,
                                              function:
                                                key.mentorRequest.requestJson
                                                  .function,
                                              sub_function:
                                                key.mentorRequest.requestJson
                                                  .sub_function,
                                              stage:
                                                key.mentorRequest.requestJson
                                                  .stage,
                                              purpose:
                                                key.mentorRequest
                                                  .purposeOfMentorship,
                                            };
                                            setModalData3(requestJson);
                                            setModalOpen3(true);
                                          }}
                                        >
                                          {"S" +
                                            key?.startup?.id.substring(
                                              key?.startup?.id.length - 6
                                            )}
                                          <span
                                            className="tooltiptext tooltip-bottom"
                                            style={{
                                              left: "3rem",
                                              top: "33px",
                                              width: "221px",
                                            }}
                                          >
                                            View Mentorship Requirement
                                          </span>
                                        </div>
                                        <div
                                          style={{
                                            position: "relative",
                                            // top: "0.75rem",
                                          }}
                                        >
                                          {key?.startup?.organization_name}
                                        </div>

                                        <div
                                          style={{
                                            position: "relative",
                                            // top: "0.75rem",
                                          }}
                                        >
                                          {"R" +
                                            key?.requestId.substring(
                                              key?.requestId.length - 6
                                            )}
                                        </div>
                                        <div
                                          className="newuserTooltip"
                                          style={{
                                            cursor: "pointer",
                                            position: "absolute",
                                            padding: "12px",
                                            right: "0px",
                                            bottom: "0px",
                                          }}
                                          onClick={() => {
                                            redirectProfile(
                                              key?.startup?.dippNumber
                                            );
                                          }}
                                        >
                                          <img
                                            src={startupMiniCircle}
                                            height={40}
                                            width={40}
                                          />
                                          <span
                                            className="tooltiptext tooltip-bottom "
                                            style={{
                                              left: "46px",
                                              top: "60px",
                                              width: "150px",
                                            }}
                                          >
                                            View Startup Profile
                                          </span>
                                        </div>
                                      </div>
                                    </td>
                                  </>
                                );
                              })}
                          </td>
                          <td className="matchList-tooltip p-0">
                            {item.mentorships !== undefined &&
                              item.mentorships?.length > 0 &&
                              item.mentorships.map(function (key, index) {
                                return (
                                  <>
                                    <td
                                      style={{
                                        display: "flex",
                                        minWidth: "9.2rem",
                                      }}
                                      className="borderStartUp7"
                                    >
                                      <div>
                                        <div>
                                          M
                                          {key?.id.substring(
                                            key?.id?.length - 6
                                          )}
                                        </div>
                                        <div>
                                          {moment(key?.mentorshipDate).format(
                                            "DD/MM/YYYY"
                                          )}
                                        </div>
                                      </div>
                                      <div
                                        className="newuserTooltip"
                                        style={{
                                          cursor: "pointer",
                                          justifyContent: "flex-end",
                                          display: "flex",
                                          marginTop: "1.85rem",
                                        }}
                                        onClick={() => {
                                          window.open(
                                            `/mentor-dashboard/mentorships/engagement-summary/${key?.id}`,
                                            "_blank"
                                          );
                                        }}
                                      >
                                        <img
                                          src={mentorshipMiniCircle}
                                          className="miniStartupCircle22"
                                        />
                                        <span
                                          className="tooltiptext tooltip-bottom  "
                                          style={{
                                            left: "47px",
                                            width: "148px",
                                            top: "80px",
                                            height: "51px",
                                          }}
                                        >
                                          View Mentorship Engagement
                                        </span>
                                      </div>
                                    </td>
                                  </>
                                );
                              })}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={8} style={{ border: "none" }}>
                          {" "}
                          <div
                            className="no-records"
                            style={{ marginLeft: "8rem" }}
                          >
                            No Matches Found
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className="pagination-box">
                  {cohortMatchPaginate !== undefined && (
                    <Pagination
                      activePage={activePage}
                      itemsCountPerPage={5}
                      totalItemsCount={cohortMatchPaginate?.totalElements}
                      pageRangeDisplayed={5}
                      onChange={handlePageChange.bind(this)}
                    />
                  )}
                </div>
                <ModalRequirement
                  modalOpen={modalOpen3}
                  setModalOpen={setModalOpen3}
                  modalData={modalData3}
                />
                {/* */}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <div className="newuserTooltip top-btn">
              <Button
                onClick={handleClose}
                text="CLOSE"
                className="modalButton51 doc-upload"
              ></Button>
              <span
                className="tooltiptext   tooltip-bottom"
                style={{
                  top: "65px",
                  left: "50px",
                  width: "130px",
                  height: "25px",
                }}
              >
                Close window
              </span>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
    cohortMatchMakingList: state.MentorReducer.getMatchMakingResult.data,
    cohortMatchPaginate: state.MentorReducer.getMatchMakingResult.paginate,
  };
};

export default connect(mapStateToProps, {
  getmatchTableList,
  deleteSessionData,
})(withRouter(MentorshipSummayModal));
